// Note: Actual async implementation from
// https://github.com/JedWatson/react-select/blob/master/packages/react-select/src/Async.tsx
// defaults to search icon when no custom component is passed
import React from 'react';
import { GroupBase, useStateManager } from 'react-select';
import { AsyncProps, useAsync } from 'react-select/async';
import { Select } from './Select';
import { DropdownSearchIndicator } from './SelectComponents';
import { useDebounceLoadOptions } from './selectFilterHelpers';
import { ExtendedAsyncReactSelectProps, SelectRef, SelectType } from './selectTypes';

export const SelectAsync = React.forwardRef(function SelectAsync<Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: AsyncProps<Option, IsMulti, Group> & ExtendedAsyncReactSelectProps,
  ref: SelectRef<Option, IsMulti, Group>
) {
  const loadOptions = props.loadOptions && props.debounceInMs ? useDebounceLoadOptions(props.loadOptions, props.debounceInMs) : props.loadOptions;
  const stateManagedProps = useAsync({ ...props, loadOptions });
  const selectProps = useStateManager(stateManagedProps);
  let animateDropdownIcon = selectProps.animateDropdownIcon;

  const customComponents = { ...selectProps.components };
  if (!customComponents.DropdownIndicator) {
    customComponents.DropdownIndicator = DropdownSearchIndicator;
    animateDropdownIcon = false;
  }

  return <Select ref={ref} {...selectProps} components={customComponents} animateDropdownIcon={animateDropdownIcon} />;
}) as SelectType<ExtendedAsyncReactSelectProps>;
